import React from 'react';
import PropTypes from 'prop-types';

const StatCard = ({ value, label, suffix = '', color = 'blue', className = '' }) => {
  const colorClasses = {
    blue: 'text-blue-600',
    indigo: 'text-indigo-600',
    purple: 'text-purple-600',
    emerald: 'text-emerald-600',
    orange: 'text-orange-600',
  };

  return (
    <div className={`text-center ${className}`}>
      <div className={`text-4xl font-thin ${colorClasses[color]} mb-1`}>
        {value}{suffix}
      </div>
      <div className="text-sm font-medium text-[var(--succession-text-secondary)] uppercase tracking-wider">
        {label}
      </div>
    </div>
  );
};

StatCard.propTypes = {
  value: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  suffix: PropTypes.string,
  color: PropTypes.oneOf(['blue', 'indigo', 'purple', 'emerald', 'orange']),
  className: PropTypes.string,
};

StatCard.defaultProps = {
  suffix: '',
  color: 'blue',
  className: '',
};

export default StatCard;

